/**
 * French box-plot prompts and data titles (ADR 0099 §3). Same shape and the
 * same numbers as the English file.
 */
export const boxPlotPrompts = {
    median: () => `Quelle est la médiane ?`,
    lowerQuartile: () => `Quel est le quartile inférieur ?`,
    upperQuartile: () => `Quel est le quartile supérieur ?`,
    range: () => `Quelle est l'étendue ?`,
    interquartileRange: () => `Quel est l'écart interquartile ?`,
};

export const boxPlotContexts: { title: string; from: number; to: number; step: number }[] = [
    { title: 'Buts marqués par chaque joueur cette saison', from: 0, to: 20, step: 1 },
    { title: 'Notes à un quiz sur 20', from: 0, to: 20, step: 1 },
    { title: "Minutes que met chaque élève pour aller à l'école", from: 0, to: 40, step: 2 },
    { title: 'Hauteur des plants de tournesol (cm)', from: 0, to: 40, step: 2 },
    { title: 'Notes à un contrôle de mathématiques', from: 0, to: 100, step: 5 },
    { title: 'Âges des personnes à une fête', from: 0, to: 100, step: 5 },
];
